import Api from "./Api";
import { createQueryString } from "./ApiHelper";

export default {
  GetVouchersList(payload) {
    return Api().post(`/api/external/offers-vouchers`, payload);
  },
  ValidateVoucherCode(payload) {
    return Api().post(`/api/external/verify-voucher`, payload);
  },
  AddCustomerToSegment(payload) {
    return Api().post("/api/segments", payload);
  },
  VerifyVoucherCode(payload) {
    return Api().post(`/api/external/v2/verify-voucher`, payload);
  }
};



// WEBPACK FOOTER //
// ./src/services/PromotionServices.js